<mat-drawer-container class="mat-elevation-z2 settings-container">
	<mat-drawer disableClose="true" mode="side" opened style="width:170px;">
		<mat-action-list>
			<span>
			  <button id="agencyItem" class="button-menu" *ngIf="visibleAgencyLink"
					  matTooltipPosition="right"
					  matTooltip="Manage Agencies"
					  mat-list-item (click)="showAgencyManagement()"> Agency Management </button>
			</span>

			<span>
			  <button id="userItem" class="button-menu" *ngIf="visibleUserLink"
				matTooltipPosition="right"
				matTooltip="Manage Users and Access"
				mat-list-item (click)="showUserManagement()"> User Management </button>
			</span>

		  <span>
			  <button id="groupMgmtItem" class="button-menu" *ngIf="visibleSecurityGroupLink"
			  matTooltipPosition="right"
			  matTooltip="Define and Maintain Security Groups"
			  mat-list-item (click)="showSecurityGroupManagement()" > Group Management </button></span>
		 
		   <span>
			  <button id="securityTargetsItem" class="button-menu" *ngIf="visibleSecurityTargetLink"
			  matTooltipPosition="right"
			  matTooltip="Define and Maintain Security Target Definitions"
			  mat-list-item (click)="shoSecurityTargetsDefinitions()" > Security Elements </button></span>

		  <hr width="90%">
            <span>
			  <button id="requestTypeItem" *ngIf="visibleRequestTypeLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Service Request Types"
                      class="button-menu" mat-list-item
                      (click)="showRequestTypes()" > Request Types </button>
            </span>
            <span>
			  <button id="requestStatusItem" *ngIf="visibleRequestStatusLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Request Statuses"
                      class="button-menu" mat-list-item
                      (click)="showRequestStatus()" > Request Statuses </button>
            </span>
            <span>
			  <button id="masterRegionsItem" *ngIf="visibleRegionsLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Zip Codes and Counties"
                      class="button-menu" mat-list-item
                      (click)="showMasterRegions()" >Regions </button>
            </span>
            <span>
			  <button id="statusReasonsItem" *ngIf="visibleStatusReasonsLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Status Reasons"
                      class="button-menu" mat-list-item
                      (click)="showStatusReasons()" >Status Reasons </button>
            </span>
            <span>
			  <button id="unitOfMeasureItem" *ngIf="visibleUnitOfMeasureLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Unit of Measures"
                      class="button-menu" mat-list-item
                      (click)="showUnitOfMeasure()" >Unit Of Measures </button>
            </span>
            <span>
			  <button id="noteCategoryItem" *ngIf="visibleNoteCategoryLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Note Categories"
                      class="button-menu" mat-list-item
                      (click)="showNoteCategory()" >Note Categories </button>
            </span>
            <span>
			  <button id="documentCategoryItem" *ngIf="visibleDocumentCategoryLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Document Categories"
                      class="button-menu" mat-list-item
                      (click)="showDocumentCategory()" >Document Categories </button>
            </span>
             <span>
			  <button id="qualificationsMasterItem" *ngIf="visibleQualificationsMasterLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Master Qualification Questions"
                      class="button-menu" mat-list-item
                      (click)="showQualificationsMAsterManagement()" >Master Qualifications</button>
            </span>

            <span>
			  <button id="relationshipTypesItem" *ngIf="visibleRelationshipTypesMasterLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Member Relationship Types"
                      class="button-menu" mat-list-item
                      (click)="showRelationshipTypesManagement()" >Relationship Types</button>
            </span>
          <hr width="90%">
            <span>
			  <button id="messageDefinitionItem" *ngIf="visibleMessageDefinitionLink"
                      matTooltipPosition="right"
                      matTooltip="Define / Manage Email Message Templates"
                      class="button-menu" mat-list-item
                      (click)="showMessageDefinitions()" >Message Templates </button>
            </span>
			<span>
			  <button id="automatedEmailsItem" *ngIf="visibleAutomatedEmailsLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Automated E-mails"
                      class="button-menu" mat-list-item
                      (click)="showAutomatedEmails()" >Automated E-mails </button>
            </span>
          <hr width="90%">
		  <span>
			  <button id="emailSettingsItem" *ngIf="visibleEmailLink"
				matTooltipPosition="right"
				matTooltip="Manage E-mail Settings"
				class="button-menu" mat-list-item
				(click)="showEmailSettings()" > E-mail </button></span>

		  <span>
			  <button id="generalSettingsItem"
				  *ngIf="visibleGeneralLink"
				  matTooltipPosition="right" matTooltip="Manage General System Settings"
				  class="button-menu" mat-list-item (click)="showGeneralSettings()" > General Settings </button>
          </span>
		</mat-action-list>
	</mat-drawer>

	<mat-drawer-content class="mat-drawer-content-container">
		<app-agencysettings *ngIf="visibleAgencyManagement===true"> </app-agencysettings>
		<app-usermanagement *ngIf="visibleUserManagement===true"> </app-usermanagement>
        <app-security-groups *ngIf="visibleSecurityGroupManagement===true"> </app-security-groups>
		<app-security-target-definitions *ngIf="visibleSecurityTargetSettings===true"> </app-security-target-definitions>

        <app-requesttypes *ngIf="visibleRequestTypeManagement===true"></app-requesttypes>
        <app-requeststatuses *ngIf="visibleRequestStatusManagement===true"></app-requeststatuses>
        <app-master-regions *ngIf="visibleRegionsManagement===true"></app-master-regions>
        <app-status-reasons *ngIf="visibleStatusReasonsManagement===true"></app-status-reasons>
        <app-unitofmeasures *ngIf="visibleUnitOfMeasureManagement===true"></app-unitofmeasures>
        <app-notecategories *ngIf="visibleNoteCategoryManagement===true"></app-notecategories>
        <app-document-categories *ngIf="visibleDocumentCategoryManagement===true"></app-document-categories>

        <app-message-defs *ngIf="visibleMessageDefinitionManagement===true"></app-message-defs>
		<app-automated-emails *ngIf="visibleAutomatedEmailsManagement===true"></app-automated-emails>
		
		<app-generalsettings *ngIf="visibleGeneralSettings===true"> </app-generalsettings>
		<app-emailsettings *ngIf="visibleEmailSettings===true"> </app-emailsettings>
		<app-master-qualifications *ngIf="visibleQualificationsMasterManagement===true"> </app-master-qualifications>
        <app-relationshiptypes *ngIf="visibleRelationshipTypesManagement === true"></app-relationshiptypes>
	</mat-drawer-content>
</mat-drawer-container>
